// NPM
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import Slider from "react-slick";

// HELPERS
import { toaster } from 'Helpers/index';

// ANT COMPONENTS
import { Card, Col, Row } from 'antd';
import { CopyOutlined } from '@ant-design/icons';

// STYLE
import './platform.scss';
import './../voucher-list.scss';

import 'moment/locale/ms';

interface VoucherListPlatformComponentProps {
    bannerVoucherList: any
}

const VoucherListPlatformComponent: React.FC<VoucherListPlatformComponentProps> = ({bannerVoucherList}) => {

    let settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 2,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2,
                    infinite: bannerVoucherList.length > 2,
                    dots: true
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    infinite: bannerVoucherList.length > 1,
                    dots: true
                }
            },
        ]
    };

    const { t, i18n } = useTranslation();

    const semiCircleArray = Array(5).fill(1);

    // ADD TEXT TO COPY CLIPBOARD
    const handleCopyToClipboard = (str: string) => {
        const el = document.createElement('textarea');
        el.value = str;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);

        toaster('success', t('toaster.copiedToClipboard'));
    };

    const getFormattedLocaleDate = (dateString: any) => {
        if (i18n.language === 'ms') {
            moment.locale('ms');
        } else {
            moment.locale('en');
        }
        return moment(dateString).format('D MMMM YYYY')
    }

    return (
        <div className="voucher-deals-container mt-20">
            <Slider {...settings}>
                {
                    bannerVoucherList.map((bannerVoucher, index) => {
                        const style = (bannerVoucher.voucherType === "SHIPPING") ? { backgroundColor: '#FAA523' } : { backgroundColor: '#EE4E2E' };
                        return (
                            <Card className="banner-voucher" key={index}>
                                <div className="min-height">
                                    <div className="banner-voucher-pricing" style={style}>
                                        <div className="banner-voucher-amount">
                                            {
                                                bannerVoucher.discountType === "FIAT" ? 
                                                    `RM${bannerVoucher.discountValue} ${t('label.AmountOff')}`
                                                    : `${bannerVoucher.discountValue}% ${t('label.AmountOff')}`
                                            }
                                        </div>
                                        <div className="banner-voucher-min">
                                            {t('label.MinSpend')} RM{bannerVoucher.minAmount ? bannerVoucher.minAmount : 0}
                                        </div>
                                        {
                                            bannerVoucher?.capValue ? 
                                                <div className="banner-voucher-cap">{t('label.CappedAt')} RM{bannerVoucher.capValue}</div>
                                                : null
                                        }
                                        {
                                            semiCircleArray.map((value, index) => {
                                                return <div className="punch-hole-right media-scale" key={index} style={{bottom: `${index * 35}px`}}></div>
                                            })
                                        }
                                    </div>
                                    <div className="banner-voucher-usage-details ml-10 center-text">
                                        <div className="label">
                                            {t('label.UseBy')}
                                        </div>
                                        <div className="date">
                                            {getFormattedLocaleDate(bannerVoucher.validTo)}
                                        </div>
                                        <div className="type mt-16">
                                            {t(`voucher.${bannerVoucher.voucherType}`)}
                                        </div>
                                        <div>
                                            <div className="chip mt-20">
                                                {bannerVoucher?.voucherCode}
                                                <CopyOutlined onClick={() => handleCopyToClipboard(bannerVoucher?.voucherCode)} className="copy-icon" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Card>
                        )
                    })
                }
            </Slider>
        </div>
    )
}

export default VoucherListPlatformComponent;